/*
PM 2021-07-29
KONCEPCJA KOMPONENTU
================

Komponent kontener dla komponentu mapy ./Map
Opis propsow podawanych do dziecka mozna zobaczyc w interfejsie MapProps w komponencie ./Map

================

Funkcja getIcon zwraca pineskę odpowiedniego koloru na podstawie koloru (webSerwis /mapy/dajMapaObiekty lub /mapy/dajMapaObiekty1, zależnie od projektu)
Warianty takie jak w redmine brane z ./mapData

================
importowane komponenty:
import Map from './Map';

*/

import * as React from 'react';

import {
    getIcon, tiles
} from '../map_new/mapData';

import Map from './Map';

import { connect } from 'react-redux';

import { AppState, store, Actions } from '../../appredux';
import CONFIG from '../../cfg/config';
import { sendErrorLog } from '../common/helpers';
import { Info } from '../../api';

import {distance, Dist, HaversineInM, gpsToNumber} from '../map_new/Distance'

//GoogleAnalytics
import ReactGA from 'react-ga';






//PM 2021-11-30
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface MapContainerProps {
}

//PM 2021-10-19
//tileErrors: number[],
//tileName: string,
interface MapContainerState {
    tileErrors: string[],
    tileName: string,
   
}

//komponent zarządzający stanem mapy
//przekazuje stan i funkcje jako propsy do komponentu Map.tsx
class MapContainer extends React.Component<MapContainerProps, MapContainerState>  {

    //PM 2021-10-19
    //tileErrors: [],
    //tileId: 1,
    constructor(props: MapContainerProps) {
        super(props, {});

        this.state = {
            tileErrors: [],
            tileName: tiles[1].name,
        }
        store.dispatch(Actions.pageState.addFcmLogMessage("okno glowne mapa", 0))
        sendErrorLog("1", "1", 'okno glowne mapa')

        ReactGA.event({
          category: 'Nawigacja',
          action: 'Mapa'
        });

    }

    componentDidUpdate(prevProps: MapContainerProps) {
       
    }

    //PM 2021-10-19
    addTileError = async (aName: string) => {
        const tileErrors = this.state.tileErrors

        tileErrors.push(aName)
        this.setState({ ...this.state, tileErrors: tileErrors })
        store.dispatch(Actions.pageState.addFcmLogMessage("blad mapy", 2))
        await sendErrorLog("0", "-1", 'błąd mapy')
    }

    //PM 2021-10-19
    setTileName = async (aName: string) => {
        this.setState({ ...this.state, tileName: aName })
    }



    render = () => {


        const promien = 0.045; 

        return (
            <>
            <Map
                getIcon={getIcon} //pobieranie koloru pineski
                addTileError={this.addTileError}
                setTileName={this.setTileName}
                tileErrors={this.state.tileErrors}
                tileName={this.state.tileName}

            />
            </>
        );
    }

}

const mapStateToProps = (state: AppState) => ({
});

export default connect(mapStateToProps)(MapContainer);

